import type { UseQueryOptionsWithoutQueryKey } from 'core/react-query-config'
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import type { StoreForecastErrorResponse } from 'core/api/trajectory-photo/storeForecastError'

export interface Instore {
  reference_gmv: number | null
  reference_gmv_progression: number | null
  reference_gmv_ai: number | null
  reference_gmv_ai_progression: number | null
  reference_margin_rate: number | null
  reference_margin_rate_progression: number | null
  reference_selling_price: number | null
  reference_selling_price_progression: number | null
  reference_quantities: number | null
  reference_physical_gmv: number | null
  reference_digital_gmv: number | null
  reference_decapro_gmv: number | null
  reference_eco_non_circular_gmv: number | null
  reference_eco_circular_gmv: number | null
  reference_eco_circular_repair_and_maintenance_gmv: number | null
  reference_eco_circular_saved_products_gmv: number | null
  reference_eco_circular_buy_back_gmv: number | null
  reference_eco_circular_rental_gmv: number | null
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
}

export interface Outstore {
  reference_gmv: number | null
  reference_gmv_progression: number | null
  reference_margin_rate: number | null
  reference_margin_rate_progression: number | null
  reference_selling_price: number | null
  reference_selling_price_progression: number | null
  reference_quantities: number | null
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
}

export interface StoreForecast {
  reference_year: number
  instore: Instore
  outstore: Outstore
}

const getStoreForecast = async (config: AxiosRequestConfig): Promise<StoreForecast> => {
  const axiosPromise: AxiosResponse<StoreForecast> = await axios(config)
  return {
    ...axiosPromise.data
  }
}

export const useApiGetStoreForecast = (
  storeId: number,
  year: number,
  enabled: boolean,
  referenceStoreId?: number,
  options?: UseQueryOptionsWithoutQueryKey<StoreForecast, AxiosError<StoreForecastErrorResponse>>
) => {
  const params = referenceStoreId ? `?referenceStoreId=${referenceStoreId}` : ''
  const url = `/v1/stores/${storeId}/forecast/year/${year}${params}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<StoreForecast, AxiosError<StoreForecastErrorResponse>>({
    queryKey: ['get-store-forecast', url],
    queryFn: () => getStoreForecast(config),
    enabled,
    ...options
  })
}
